import { gsap, Expo } from 'gsap'

export const getTypeFromSource = (source) => {
  return (typeof source === 'object') ? 'mp4' : 'hls'
}

export const revealElement = (node, options) => {
  if (options.fade) {
    gsap.fromTo(
      node,
      {
        opacity: 0,
        y: -20,
        display: 'none'
      },
      {
        opacity: 1,
        y: 0,
        display: 'block',
        duration: 0.25,
        ease: Expo.easeOut
      })
  } else if (options.slideDown) {
    gsap.fromTo(
      node,
      {
        y: '-100%',
        opacity: 0.5
      },
      {
        duration: 1,
        y: '0%',
        opacity: 1,
        ease: Expo.easeOut
      })
  } else if (options.slideLeft) {
    gsap.fromTo(
      node,
      {
        x: '100%',
        opacity: 0.5
      },
      {
        duration: 0.5,
        x: '0%',
        opacity: 1,
        ease: Expo.easeOut
      })
  } else {
    node.classList.remove('_hide')
  }
}

export const hideElement = (node, options) => {
  if (options.fade) {
    gsap.to(node, {
      duration: 0.25,
      opacity: 0,
      y: -20,
      display: 'none',
      ease: Expo.easeOut
    })
  } else if (options.slideUp) {
    gsap.to(node, {
      duration: 1,
      opacity: 0.5,
      y: '-100%',
      ease: Expo.easeOut
    })
  } else if (options.slideRight) {
    gsap.to(node, {
      duration: 0.5,
      opacity: 0.5,
      x: '100%',
      ease: Expo.easeOut
    })
  } else {
    node.classList.add('_hide')
  }
}

export const registerPluginOnce = (videojs, pluginName, pluginObj) => {
  // Check if plugin already exist
  if (!videojs.getPlugin(pluginName)) {
    // Register the plugin
    videojs.registerPlugin(pluginName, pluginObj)
  }
}

/**
 * Conditional error raising
 *
 * @param {Boolean} condition a boolean condition, if true, will call error()
 * @param {String} errorMsg message pass to error()
 * @param {Object} context object will be output in console
 * @param {Function} onErrorFn if set, a function that get call upon error
 * @param {Boolean} fatal if false, will only log the error. if true, will throw new Error
 */
export const conditionalError = (condition, errorMsg, context, onErrorFn = false, fatal = false) => {
  if (condition) {
    error(errorMsg, context, fatal)
    if (onErrorFn) {
      onErrorFn()
    }
  }
}

/**
 * Shorcut for console.error or throw new Error
 *
 * @param {String} msg message pass to error()
 * @param {Object} context object will be output in console
 * @param {Boolean} fatal if false, will only log the error. if true, will throw new Error
 */
export const error = (msg, context, fatal = false) => {
  if (!fatal) {
    console.error(msg, context)
  } else {
    throw new Error(msg, context)
  }
}

/**
 * Check if a script|style is already present in DOM
 *
 * @param {String} url ressource url
 * @returns true if present, false otherwise
 */
export const isUrlInDom = (url) => {
  return document.querySelectorAll(`[src="${url}"]`).length !== 0
}

/**
 * Check if offset is a number greater than 0
 * 
 * @param {*} offset 
 */
export const isValidOffset = offset => {
  return offset && typeof offset === 'number' && offset > 0
}